import { render, staticRenderFns } from "./signup.component.vue?vue&type=template&id=1cc632ee"
import script from "./signup.component.ts?vue&type=script&lang=ts&external"
export * from "./signup.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports